import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Dict } from "../types";
import { Injectable } from "@angular/core";
import { ProjectHttpService } from "../generated/project-http.service";


@Injectable()
export class ProjectOptionsResolver implements Resolve<Dict<{ name: string; isCertify: boolean }>> {

  constructor(private projectHttpService: ProjectHttpService) {

  }

  async resolve(route: ActivatedRouteSnapshot) {

    const items = await this.projectHttpService.getItems('').toPromise();

    const result: any = {};

    for (let item of items) {

      const name = item.code != undefined && item.code.length > 0
        ? `${item.code} - ${item.name}`
        : item.name;

      result[item.id.toString()] = { name, isCertify: item.isCertify };
    }

    return result;
  }

}
